
// import { ImageItem } from "@school/a2z-lib";

export const HealthIconPath = './assets/media/svg/icons/a2z/healthcare.svg';
export const LogoPath = './assets/media/logos/logo-dark.svg';
export const UserimgPath = './assets/media/users/';
export const CloseIconPath = './assets/media/svg/icons/Navigation/Close.svg';
export const ChatIconPath = './assets/media/svg/icons/Communication/Chat2.svg';
export const StartIconPath = './assets/media/svg/icons/Media/Play.svg';
export const ResumeIconPath = './assets/media/svg/icons/Media/Repeat.svg';
export const StopIconPath = './assets/media/svg/icons/Code/Stop.svg';
export const CallIconPath = './assets/media/svg/icons/Communication/Call.svg';
export const CreateConsultIconPath = './assets/media/svg/icons/Devices/Display3.svg';
export const TelconsultIconPath = './assets/media/svg/icons/Media/teleconsult.svg';
